import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Chip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WifiIcon from '@mui/icons-material/Wifi';
import GavelIcon from '@mui/icons-material/Gavel';
import Services from './Services';
import ImgnHero from '../../img/background2.jpeg';
import ImgnHero2 from '../../img/backgroundMin.jpeg';
import imgnLogo from '../../img/redcomlgo2.png';

const navItems = [
  { label: 'Inicio', id: 'inicio' },
  { label: 'Servicios', id: 'servicios' },
  { label: 'Cobertura', id: 'cobertura' },
  { label: 'Legal', id: 'legal' },
  { label: 'Contacto', id: 'contacto' }
];

const coverageData = [
  { num: '01', localidad: 'El Salto', municipio: 'Acapulco de Juárez', estado: 'Guerrero' },
  { num: '02', localidad: 'La Estación', municipio: 'Acapulco de Juárez', estado: 'Guerrero' },
  { num: '03', localidad: 'Cerro de Piedra', municipio: 'Acapulco de Juárez', estado: 'Guerrero' }
];

export default function LandingPage() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 64; 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileOpen(false);
  };

  return (
    <Box sx={{ flexGrow: 1, backgroundColor: '#f8f9fa', overflowX: 'hidden' }}>
      {/* NAVBAR */}
      <AppBar position="sticky" sx={{ backgroundColor: '#0d47a1', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', letterSpacing: 1, color: 'white' }}>
                REDCOMP
              </Typography>
            </Box>
            
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
              {navItems.map((item) => (
                <Button key={item.id} onClick={() => scrollToSection(item.id)} sx={{ color: '#fff' }}>
                  {item.label}
                </Button>
              ))}
            </Box>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { md: 'none' }, color: 'white' }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* DRAWER MOBILE */}
      <Drawer 
        anchor="right" 
        open={mobileOpen} 
        onClose={handleDrawerToggle}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        <Box sx={{ width: 250, pt: 8 }}>
          <List>
            {navItems.map((item) => (
              <ListItem button key={item.id} onClick={() => scrollToSection(item.id)}>
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* --- HERO RESPONSIVO --- */}
      <Box
        id="inicio"
        sx={{
          position: 'relative',
          backgroundImage: {xs:`url(${ImgnHero2})`,md: `url(${ImgnHero})`},
          backgroundPosition: 'center',
          backgroundSize:'cover',
          backgroundRepeat: 'no-repeat',
          width:{xs:'auto', md:'auto'},
          height:{xs:'420px',md:'420px'},
          color: 'white',
          // Altura flexible ajustada a contenido y pantallas
          minHeight: { xs: 'auto', md: 'auto' }, 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 6, md: 10 }
        }}
      >
        {/* Overlay oscuro para lectura ágil */}
        <Box 
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.55)',
            zIndex: 1
          }}
        />

        {/* Contenido del Hero */}
        <Container maxWidth="md" sx={{ zIndex: 2, textAlign: 'center', px: 2 }}>
          <WifiIcon sx={{ fontSize: { xs: 45, sm: 60, md: 70 }, mb: 2, color: '#00e676' }} />
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom 
            sx={{ 
              fontWeight: 'bold',
              fontSize: { xs: '1.4rem', sm: '2.4rem', md: '3.4rem' },
              lineHeight: 1.2
            }}
          >
            Conexión de Alta Velocidad
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              opacity: 0.95, 
              mb: 4,
              fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' },
              fontWeight: 'normal',
              maxWidth: '700px',
              mx: 'auto'
            }}
          >
            Internet estable y continuo para tu hogar y negocio en Acapulco y región Guerrero.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => scrollToSection('contacto')}
            sx={{ 
              fontWeight: 'bold',
              backgroundColor: '#00e676', 
              color: '#0d47a1',
              padding: { xs: '10px 24px', md: '12px 36px' },
              fontSize: { xs: '0.8rem', md: '1.1rem' },
              borderRadius: '28px',
              '&:hover': { backgroundColor: '#00c853' } 
            }}
          >
            Contratar Servicio
          </Button>
        </Container>
      </Box>

      {/* SERVICIOS */}
      <Container id="servicios" sx={{ py: { xs: 6, md: 10 } }}>
        <Typography variant="h4" align="center" gutterBottom sx={{ fontFamily:'fantasy',fontSize: { xs: '1.8rem'}, fontWeight: 'bold', mb: 4 }}>
          Nuestros Servicios y Equipamiento
        </Typography>

        {/* Sección de Tarjetas de Precios de tu componente Services */}
        <Box sx={{ mb: 6 }}>
          <Services />
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2 }}>
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography variant="h5" component="div" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Internet Residencial y Comercial
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                  Ofrecemos planes de acceso a internet adaptados a tus necesidades con alta disponibilidad y estabilidad, bajo cumplimiento normativo.
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AccessTimeIcon fontSize="small" color="action" /> Horario de Instalación y Visitas Técnicas:
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ pl: 3 }}>
                  • Lunes a Viernes: 9:00 am – 5:00 pm
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ pl: 3 }}>
                  • Sábados: 9:00 am – 2:00 pm
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2 }}>
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography variant="h5" component="div" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Equipo Terminal Homologado
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                  Utilizamos infraestructura de vanguardia para garantizar la mejor experiencia de navegación y simetría en el servicio.
                </Typography>
                <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  <Chip label="Marca: HUAWEI" color="primary" variant="filled" />
                  <Chip label="Modelo: EG8021V5" color="primary" variant="filled" />
                </Box>
                <Typography variant="caption" display="block" sx={{ mt: 2, color: 'text.secondary', fontStyle: 'italic' }}>
                  *Equipo sujeto a disponibilidad, entregado en esquema de comodato o compraventa según contrato.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* COBERTURA */}
      <Box id="cobertura" sx={{ backgroundColor: '#eef2f6', py: { xs: 6, md: 10 } }}>
        <Container>
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            Áreas de Cobertura Actual
          </Typography>
          <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>
            Brindamos servicio en localidades clave que cuentan con la infraestructura necesaria para garantizar la calidad.
          </Typography>
          <TableContainer component={Paper} sx={{ maxWidth: 800, margin: '0 auto', boxShadow: 3, borderRadius: 2, overflowX: 'auto' }}>
            <Table>
              <TableHead sx={{ backgroundColor: '#1565c0' }}>
                <TableRow>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Núm.</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Localidad</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Municipio</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {coverageData.map((row) => (
                  <TableRow key={row.num} hover>
                    <TableCell sx={{ fontWeight: 'bold', color: '#1565c0' }}>{row.num}</TableCell>
                    <TableCell>{row.localidad}</TableCell>
                    <TableCell>{row.municipio}</TableCell>
                    <TableCell>{row.estado}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography variant="caption" display="block" align="center" sx={{ mt: 3, color: 'text.secondary' }}>
            Información basada en datos geoestadísticos del INEGI.
          </Typography>
        </Container>
      </Box>

      {/* LEGAL */}
      <Container id="legal" sx={{ py: { xs: 6, md: 10 } }}>
        <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', mb: 6 }}>
          Marco Legal y Transparencia
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: { xs: 3, md: 4 }, height: '100%', boxShadow: 2, borderTop: '4px solid #1565c0' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <GavelIcon color="primary" sx={{ mr: 2, fontSize: 30 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Contrato de Adhesión (PROFECO)
                </Typography>
              </Box>
              <Typography variant="body2" paragraph color="text.secondary">
                Nuestro servicio se provee bajo el amparo del título habilitante correspondiente, en estricto cumplimiento con la Ley Federal de Telecomunicaciones y Radiodifusión (LFTR) y la Ley Federal de Protección al Consumidor (LFPC).
              </Typography>
              <Typography variant="body2" color="text.secondary">
                El paquete incluye un contrato de adhesión estándar aprobado por PROFECO, válido para contrataciones por plazo indefinido o forzoso.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: { xs: 3, md: 4 }, height: '100%', boxShadow: 2, borderTop: '4px solid #1565c0' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <LocationOnIcon color="primary" sx={{ mr: 2, fontSize: 30 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Seguridad y Datos Personales
                </Typography>
              </Box>
              <Typography variant="body2" paragraph color="text.secondary">
                Operamos adheridos a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>
                Área Responsable de Seguridad y Justicia:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Río Atoyac 267, Col. Cayaco, CP 39905, Acapulco, Gro.<br />
                Tel: 7447505274 | redcompsoporte@gmail.com
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* CONTACTO Y FOOTER */}
      <Box id="contacto" sx={{ backgroundColor: '#0d47a1', color: 'white', mt: 4 }}>
        <Container sx={{ py: 8 }}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'center', gap: 2, mb: 6 }}>
            <Typography variant="h4" align="center" sx={{ fontWeight: 'bold' }}>
              Atención y Soporte
            </Typography>
            <Box
              component="img"
              src={imgnLogo}
              alt="REDCOMP Logo"
              sx={{
                height: 70,
                backgroundColor: 'white',
                border: '2px solid #fff',
                borderRadius: '20%',
                p: 0.5
              }}
            />
          </Box>
          
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <LocationOnIcon sx={{ mt: 0.5, color: '#00e676' }} />
                <Box>
                  <Typography variant="h6" gutterBottom>Oficina Central</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Río Atoyac 267, Colonia Cayaco,<br />
                    C.P. 39905, Acapulco de Juárez, Guerrero.
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8, mt: 1, fontStyle: 'italic' }}>
                    (Mismo domicilio para oír/recibir notificaciones)
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <AccessTimeIcon sx={{ mt: 0.5, color: '#00e676' }} />
                <Box>
                  <Typography variant="h6" gutterBottom>Horario de Atención</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Lunes a Viernes:<br />
                    9:00 am – 6:00 pm
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <PhoneIcon sx={{ mt: 0.5, color: '#00e676' }} />
                <Box>
                  <Typography variant="h6" gutterBottom>Canales Digitales</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    <strong>Teléfono/Celular:</strong>{' '}
                    <a style={{ textDecoration: 'none', color: 'white' }} href="tel:+527447505274">
                      7447505274
                    </a>
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                    <strong>Atención, Quejas y Facturación:</strong><br />
                    <a href="mailto:redcompsoporte@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                      redcompsoporte@gmail.com
                    </a>
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                    <strong>Web:</strong>{' '}
                    <a href="https://redcompweb.net/" style={{ color: 'inherit', textDecoration: 'none' }}>
                      https://redcompweb.net/
                    </a>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
        
        <Box sx={{ backgroundColor: '#0a3d8c', py: 3, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <Container>
            <Typography variant="body2" align="center" sx={{ opacity: 0.7 }}>
              © {new Date().getFullYear()} REDCOMP. Proveedor de Servicios de Telecomunicaciones. Todos los derechos reservados.
            </Typography>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}